const { sanitiseBatchNo } = require('./tools')

function createUpsertBatchDetails ({ mainApi, logger }) {
  return async function upsertBatchDetails ({ skuCode, batchNo, manufacturer, expiry }) {
    if (!skuCode || !batchNo) return
    const sanitizedBatchNo = sanitiseBatchNo(batchNo)
    const productId = `product:${skuCode}`
    const manufacturerId = manufacturer && manufacturer !== '' ? manufacturer : 'unknown'

    try {
      await mainApi.batch.new({
        productId,
        manufacturer: manufacturerId,
        batchNo: sanitizedBatchNo,
        expiry
      }, { validateManufacturer: false, allowUpdates: true })
    } catch (err) {
      const batchId = `product:${skuCode}:manufacturer:${manufacturerId}:batchNo:${sanitizedBatchNo}`
      logger.warn({ err, batchId }, 'failed to upsert batch')
    }
  }
}

module.exports = createUpsertBatchDetails
